(function ($) {
    $.nette.ext('note-overview', {
        init() {
            const obj = this;
            this.ext('snippets', true).after($.proxy(($el) => {
                obj.hideSubmit($el.find('#frm-noteOverview-component-assigneeForm-aut_d_user_id_solver'));
                obj.hideSubmit($el.find('#frm-noteOverview-component-actionForm-fin_c_order_item_status_id'));
            }, this));

            obj.hideSubmit($('#frm-noteOverview-component-assigneeForm-aut_d_user_id_solver'));
            obj.hideSubmit($('#frm-noteOverview-component-actionForm-fin_c_order_item_status_id'));
        },
    }, {
        hideSubmit($el) {
            const $input = $el;
            const $form = $input.closest('form');
            const $button = $form.find('input[type="submit"]');

            $button.hide();
            $input.on('change', () => {
                $form.submit();
            });
        },
    });
}(jQuery));
